import { Injectable, isDevMode } from '@angular/core';
import { WebchatEvent, WebchatInstance } from '@conversational/chat-models';

@Injectable({
  providedIn: 'root',
})
export class CognigyClientAnalyticsService {
  readonly #listeners: ((event: WebchatEvent) => void)[] = [];
  #isRegistered = false;

  /**
   * Register the Cognigy Analytics Service for a webchat instance. This should be done only once.
   * @param webchat
   */
  registerAnalytics(webchat: WebchatInstance) {
    if (!this.#isRegistered) {
      webchat.registerAnalyticsService((event) => {
        this.notifyListeners(event);
      });
      this.#isRegistered = true;
    } else if (isDevMode()) {
      console.warn('Cognigy Client Analytics service is already registered');
    }
  }

  addListener(addEvent: (event: WebchatEvent) => void) {
    this.#listeners.push(addEvent);
  }

  notifyListeners(event: WebchatEvent) {
    this.#listeners.forEach((listener) => {
      try {
        listener(event);
      } catch (error) {
        if (isDevMode()) {
          console.error('Cognigy Client Analytics listener error:', error);
        }
      }
    });
  }
}
